/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentGameInfo } from './TournamentGameInfo';
import {
    TournamentGameInfoFromJSON,
    TournamentGameInfoFromJSONTyped,
    TournamentGameInfoToJSON,
    TournamentGameInfoToJSONTyped,
} from './TournamentGameInfo';

/**
 * 
 * @export
 * @interface GetTournamentGamesResponse
 */
export interface GetTournamentGamesResponse {
    /**
     * 
     * @type {Array<TournamentGameInfo>}
     * @memberof GetTournamentGamesResponse
     */
    games?: Array<TournamentGameInfo>;
}

/**
 * Check if a given object implements the GetTournamentGamesResponse interface.
 */
export function instanceOfGetTournamentGamesResponse(value: object): value is GetTournamentGamesResponse {
    return true;
}

export function GetTournamentGamesResponseFromJSON(json: any): GetTournamentGamesResponse {
    return GetTournamentGamesResponseFromJSONTyped(json, false);
}

export function GetTournamentGamesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTournamentGamesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'games': json['games'] == null ? undefined : ((json['games'] as Array<any>).map(TournamentGameInfoFromJSON)),
    };
}

export function GetTournamentGamesResponseToJSON(json: any): GetTournamentGamesResponse {
    return GetTournamentGamesResponseToJSONTyped(json, false);
}

export function GetTournamentGamesResponseToJSONTyped(value?: GetTournamentGamesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'games': value['games'] == null ? undefined : ((value['games'] as Array<any>).map(TournamentGameInfoToJSON)),
    };
}

